import { Decorator, FormApi, FormState, getIn } from 'final-form';
import { Calculation, Updates } from 'final-form-calculate-pmed/index';

// alternative version of final-form-calculate that adds option to ignore updates on InitialValues
// see:
// - https://github.com/final-form/final-form-calculate/issues/26
// - https://github.com/final-form/final-form-calculate/pull/45/commits/8208d7917e8a4a423ec35413e32c6b5980767344


const tripleEquals = (a: any, b: any) => a === b;

const isPromise = (obj : any) =>
    !!obj &&
    (typeof obj === 'object' || typeof obj === 'function') &&
    typeof obj.then === 'function';

const createPmedDecorator = (
    ...calculations: Calculation[]
): Decorator => (form: FormApi) => {

  // Register the fields to be able to get their state using form.getFieldState()
  // calculations.forEach(calculation => {
  //   form.registerField(calculation.field as string, () => {}, {value: true, pristine: true});
  // });

  let previousValues = {};
  const unsubscribe = form.subscribe(
      (formState: FormState) => {

        const {values} = formState;

        form.batch(() => {

          const runUpdates = (
              field: string,
              isEqual: (a: any, b: any) => boolean,
              updates: Updates
          ) => {
            const next = values && getIn(values, field)
            const previous = previousValues && getIn(previousValues, field)
            if (!isEqual(next, previous)) {
              if (typeof updates === 'function') {
                const results = updates(next, field, values, previousValues)
                if (isPromise(results)) {
                  results.then((resolved: any) => {
                    Object.keys(resolved).forEach(destField => {
                      form.change(destField, resolved[destField])
                    })
                  })
                } else {
                  Object.keys(results).forEach(destField => {
                    form.change(destField, results[destField])
                  });
                }
              } else {
                Object.keys(updates).forEach(destField => {
                  const update = updates[destField];
                  const result = update(next, values, previousValues);
                  if (isPromise(result)) {
                    result.then((resolved : any)=> {
                      form.change(destField, resolved);
                    });
                  } else {
                    form.change(destField, result);
                  }
                });
              }
            }
          };

          const fields = form.getRegisteredFields();

          // const isPristine = (fieldName: string) =>
          //     form.getFieldState(fieldName) && form.getFieldState(fieldName)!.pristine;
          const isPristine = (fieldName: string) => form.getState().pristine;

          calculations.forEach(
              (calculation) => {

                const {
                  field,
                  isEqual,
                  updates,
                  updateOnPristine = true
                } = calculation;

                if (
                    (updateOnPristine && typeof field === 'string')
                    ||  (!updateOnPristine &&  typeof field === 'string' && !isPristine(field))
                ) {
                  runUpdates(field, isEqual || tripleEquals, updates)
                } else if (typeof field !== 'string') {
                  // field is a either array or regex
                  const matches = Array.isArray(field)
                      ? (name: any) => ~field.indexOf(name) || field.findIndex(f => f instanceof RegExp && (f as RegExp).test(name)) !== -1
                      : (name: any) => (field as RegExp).test(name);
                  fields.forEach(fieldName => {
                    if (
                        (updateOnPristine && matches(fieldName)) ||
                        (!updateOnPristine &&
                            matches(fieldName) &&
                            !isPristine(fieldName))
                    ) {
                      runUpdates(fieldName, isEqual || tripleEquals, updates)
                    }
                  })
                }
              }
          );

          previousValues = values;
        })
      },
      { values: true }
  );
  return unsubscribe;
}

export default createPmedDecorator;
